import api from "../../utils/axios-util";
import * as mutation_type from "../mutation-types";
import config from "@/config/index";
const state = config.TeamManagement;

const getters = {
    team_source: state =>  state.TeamManagement.source,
    team_channel: state =>  state.TeamManagement.channel
}
const mutations = {
    [mutation_type.CommitNothing]: () => { },
    [mutation_type.TEAM_SOURCE]: (state, response) => {
        state.TeamManagement.source = response
    },
    [mutation_type.TEAM_CHANNEL]: (state, response) => {
        state.TeamManagement.channel = response
    }
};
const actions = {
    insertTeam: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/team/create`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    GetTeam: ({ commit },payload) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/team/fetch?skip=${payload.skip}&take=${payload.take}`).then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    fetchmembers: ({ commit }) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/team/fetchmembers`).then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    FilterTeam: ({ commit }, query) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/team/fetch`,{ params: query }).then(response => {
                    
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    deleteTeam: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .delete(`/team/delete/${payload}`)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing, {});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    updateTeam: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                const id = payload.id;
                delete payload.id;
                api
                    .put(`/team/update/${id}`, payload)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing, {});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    TeamSouceChannel({ commit }){
        let team = localStorage.getItem("Team")
        if(team !== null){
            let source = []
            let channel = []
            team = JSON.parse(team)
            for (let i = 0; i < team.length; i++) {
                const element = team[i];
                source = [...source,...element.type_data.source.map(elm => elm.name)]
                channel = [...channel,...element.type_data.channel.map(elm => elm.name)]
            }
            source = [...new Set(source)]
            channel = [...new Set(channel)]
            commit(mutation_type.TEAM_SOURCE, source);
            commit(mutation_type.TEAM_CHANNEL, channel);

            if(team.length === 0 ){
                return team.length !== 0 ;
            }
        }
        
    },
    addSource({ commit }, payload){
        commit(mutation_type.TEAM_SOURCE, payload);
    },
    addChannel({ commit }, payload){
        commit(mutation_type.TEAM_CHANNEL, payload);
    }
};
export default {
    state,
    mutations,
    actions,
    getters
};